import React, { useContext } from 'react';
import './TopBar.scss';
import ejLogo from '../../assets/edj-logo-2.svg';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';

const TopBar = () => {
  const locId = useContext(LocaleContext);

  return (
    <header>
      <div className="header-container">
        <div className="logo-container">
          <a
            href={getText(locId, 'AllPages', 'link', 'TopBar')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img alt="Edward Jones Logo" className="logo" src={ejLogo} />
          </a>
        </div>
        <div className="title-container">
          <p>{getText(locId, 'AllPages', 'heading', 'TopBar')}</p>
        </div>
      </div>
      <hr aria-hidden />
    </header>
  );
};

export default TopBar;
